import omit from 'lodash/omit';
import pick from 'lodash/pick';
import get from 'lodash/get';

const _extractAssessmentData = (data) =>
  pick(data, [
    'id',
    'is_cb_practice_quiz',
    'is_ppc',
    'is_practice_exam',
    'is_sample_quiz',
    'is_secure',
    'is_spp',
    'title',
  ]);

const _extractAssignmentData = (data) =>
  pick(data, ['id', 'opened', 'starts_at', 'status', 'teacher_assigned']);

const connectLeanUpdateAssignments = ({
  assignmentsResponse,
  totalAssignees,
  saveAssignedState,
  onItemAction,
  disablePpcAutoAssignFlag = false,
  useNewAssignModalFlag = false,
  studentsBySection,
}) => {
  let updatedAssignmentsInfo, assignResponses;

  if (useNewAssignModalFlag) {
    const { assignments = [] } = assignmentsResponse;

    updatedAssignmentsInfo = assignments.map(_extractAssignmentData);

    assignResponses = assignments.map((assignment) => {
      const { sub_group_students = [], section_id } = assignment;
      const isISA = sub_group_students?.length > 0;
      const subGroupStudentsDetails = get(studentsBySection, section_id, [])
        .filter((student) => sub_group_students.includes(student.id))
        .map((s) => {
          return {
            ...s,
            /**
             * TODO: Figure out what needs these keys
             * and check if adapting to use id is trivial.
             */
            userId: s.id,
            studentId: s.id.toString(),
          };
        });

      return {
        ...omit(assignment, ['students', 'sub_group_students']),
        item: _extractAssessmentData(assignmentsResponse),
        section_students: [],
        is_individual_assignment: isISA,
        students: subGroupStudentsDetails,
      };
    });
  } else {
    const [lastAssignmentResponse] = assignmentsResponse;

    const {
      opened,
      starts_at,
      status,
      teacher_assigned,
      id,
      assignment_ids: assignmentIds,
    } = lastAssignmentResponse;
    updatedAssignmentsInfo = totalAssignees.map((section) => {
      return {
        id: section.assignmentId || id,
        opened,
        starts_at,
        status,
        teacher_assigned,
      };
    });

    /**
     * Rebuild the assignResponses from the list of assignmentId
     */
    assignResponses = Object.keys(assignmentIds).map((sectionId) => {
      const assignmentId = assignmentIds[sectionId];
      const { subStudents, isIndividualAssignment } = totalAssignees.find(
        (assignee) => assignee.id === sectionId,
      );

      return {
        ...omit(lastAssignmentResponse, [
          'students',
          'sub_group_students',
          'is_individual_assignment',
        ]),
        section_id: sectionId,
        id: assignmentId,
        section_students: [],
        students: subStudents || [],
        /**
         * Get `isIndividualAssignment` from `totalAssigneed` instead of `lastAssignmentResponse`. The reason behind is
         * `lastAssignmentResponse` contains information only about LAST CREATED ASSIGNMENT while `totalAssignees`
         * contains data about the specific assignment for a class.
         * */
        is_individual_assignment: isIndividualAssignment || false,
      };
    });
  }

  saveAssignedState(
    updatedAssignmentsInfo,
    assignResponses,
    disablePpcAutoAssignFlag,
  );
  onItemAction && onItemAction();
};

export default connectLeanUpdateAssignments;
